// extracted by mini-css-extract-plugin
export default {"errorText":"src-modules-form-InputWrapper-style__errorText_zNenX"};